import React, { useState } from "react";
import { FaUser, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [formSent, setFormSent] = useState(false);
  const [isSending, setIsSending] = useState(false); // controla o loading do botão

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true); // começa o loading

    const form = e.target;

    emailjs
      .sendForm("service_czfac4o", "template_d2jztzf", form, "lbuZ2q-6hgq2KE01C")
      .then(
        (result) => {
          console.log(result.text);
          setFormSent(true);
          setIsSending(false); // para o loading
        },
        (error) => {
          console.log(error.text);
          alert("Erro ao enviar. Tente novamente.");
          setIsSending(false); // para o loading mesmo em erro
        }
      );
  };

  return (
    <div
      className="container p-3 mt-2 mb-4"
      style={{
        backgroundColor: "#fff",
        border: "2px solid #ccc",
        borderRadius: "20px 0px 20px 0px",
        maxWidth: "800px",
        margin: "0 auto",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {!formSent ? (
        <form onSubmit={handleSubmit}>
          {/* Título */}
          <h5 className="mb-5 fw-bold">Ainda tem dúvidas? Entre em contato!</h5>

          <div className="row mt-3">
            {/* Campos de Entrada */}
            <div className="col-md-6">
              <div className="mb-3 d-flex align-items-center">
                <FaUser
                  style={{
                    color: "#888",
                    fontSize: "18px",
                    marginRight: "10px",
                  }}
                />
                <input
                  type="text"
                  name="from_name"
                  className="form-control"
                  placeholder="Nome"
                  required
                />
              </div>

              <div className="mb-3 d-flex align-items-center">
                <FaEnvelope
                  style={{
                    color: "#888",
                    fontSize: "18px",
                    marginRight: "10px",
                  }}
                />
                <input
                  type="email"
                  name="reply_to"
                  className="form-control"
                  placeholder="E-mail"
                  required
                />
              </div>

              <div className="mb-3 d-flex align-items-center">
                <FaWhatsapp
                  style={{
                    color: "#888",
                    fontSize: "18px",
                    marginRight: "10px",
                  }}
                />
                <input
                  type="text"
                  name="whatsapp"
                  className="form-control"
                  placeholder="WhatsApp"
                  required
                />
              </div>
            </div>

            {/* Campo de Mensagem */}
            <div className="col-md-6">
              <label className="">Mensagem ou Dúvida:</label>
              <textarea
                name="message"
                className="form-control"
                rows="4"
                placeholder="Digite sua mensagem..."
                required
              ></textarea>

              {/* Botão Enviar com loading */}
              <button
                type="submit"
                className="btn btn-secondary mt-3 text-black d-flex align-items-center justify-content-center"
                style={{
                  float: "right",
                  backgroundColor: "#D1D1D1",
                  minWidth: "140px",
                  height: "45px",
                }}
                disabled={isSending}
              >
                {isSending ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Enviando...
                  </>
                ) : (
                  "Enviar"
                )}
              </button>
            </div>
          </div>

          {/* Aviso de Privacidade */}
          <p
            className="text-muted text-center mt-3"
            style={{ fontSize: "12px" }}
          >
            *Respeitamos sua privacidade e garantimos que suas informações serão
            usadas apenas para atender sua solicitação.
          </p>
        </form>
      ) : (
        <div className="text-center p-5">
          <h4 className="fw-bold" style={{ color: "#ECA600" }}>
            Agradecemos o envio!
          </h4>
          <p className="mt-3 fs-5">Entraremos em contato em breve.</p>
        </div>
      )}
    </div>
  );
};

export default ContactForm;

